import { TranslationObject } from '@ngx-translate/core';

// Statically import every translation file so they are compiled into the JS
// bundle. No network request needed — translations are available synchronously
// from the first JS tick, even on a first install with no connectivity.
import en from '../../assets/i18n/en.json';
import zu from '../../assets/i18n/zu.json';
import xh from '../../assets/i18n/xh.json';
import af from '../../assets/i18n/af.json';
import nso from '../../assets/i18n/nso.json';
import tn from '../../assets/i18n/tn.json';
import st from '../../assets/i18n/st.json';
// "ts" is a valid identifier even though it looks like the TS abbreviation.
// eslint-disable-next-line @typescript-eslint/no-shadow
import ts_lang from '../../assets/i18n/ts.json';
import ss from '../../assets/i18n/ss.json';
import ve from '../../assets/i18n/ve.json';
import nr from '../../assets/i18n/nr.json';

export const BUNDLED_TRANSLATIONS: Record<string, TranslationObject> = {
  en, zu, xh, af, nso, tn, st,
  ts: ts_lang,
  ss, ve, nr,
} as Record<string, TranslationObject>;
